import { IPreselectDonorInfo } from '../preselect-donor-detail';
import { ICompatibilityResult, IRecipient, ISingleEpletMmRisk } from '..';
import { PotentialDonorCategory } from '@nkr/enums/potential-donor-category';
import { DonorPreselectReviewStatus } from '@nkr/enums/donor-preselect-review-status';
import { IDonorPreselectNote } from '../donor-preselect-note';

export interface IPreselectResult {
    recipient: IRecipient,
    donors: IPreselectDonor[],
}

export interface IPreselectDonor {
    donor: IPreselectDonorInfo,

    /**
     * Flat, not nested under a compatibilityResult: the grids read these four members plus the
     * donor, and the per-row recipient copy is gone - the page-level recipient serves the one
     * consumer that needed it.
     */
    failedAvoids: string[],
    hlaPointsA: number,
    hlaPointsB: number,
    hlaPointsDr: number,
    totalHlaPoints: number,
    isHardBlocked: boolean,
    isRequired: boolean,
    singleEpletMmRisk: ISingleEpletMmRisk,
    lkdpiInfo: ILkdpiInfo,
    categories: PotentialDonorCategory[],
    isPairedDonor: boolean,
    isFirst: boolean,
    reviewStatus: DonorPreselectReviewStatus,
    donorNote: IDonorPreselectNote,
    matchNote: IDonorPreselectNote,
    bmtMm: number,
    matchOfferId: number,
    responseDeadLineDate: string
    isReviewRequested: boolean,
    reviewRequestedDate: string
}

export interface ILkdpiInfo {
    lkdpiIndex: number,
    gfr: number,
    isRelated: boolean,
    hlaBMismatchCount: number,
    hlaDrMismatchCount: number
}